import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SecurityUpdateWarningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"security_update_warning"}/>
}
